import { isSectionShown } from "./data/content";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { Story } from "./components/Story";
import { Schedule } from "./components/Schedule";
import { Party } from "./components/Party";
import { Gallery } from "./components/Gallery";
import { Travel } from "./components/Travel";
import { Registry } from "./components/Registry";
import { Faq } from "./components/Faq";
import { RsvpSection } from "./components/rsvp/RsvpSection";
import { Footer } from "./components/Footer";
import { useParallax } from "./hooks/useParallax";
import { useLandingScroll } from "./hooks/useLandingScroll";

export function WeddingPage() {
  useParallax();
  useLandingScroll();

  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <div className="page">
        <Nav />
        <main id="main">
          <Hero />
          {isSectionShown("story") && <Story />}
          {isSectionShown("schedule") && <Schedule />}
          {isSectionShown("party") && <Party />}
          {isSectionShown("gallery") && <Gallery />}
          <Travel />
          {isSectionShown("registry") && <Registry />}
          <Faq />
          {isSectionShown("rsvp") && <RsvpSection />}
        </main>
        <Footer />
      </div>
    </>
  );
}
